import JsSIP from "jssip";
import store from "../store";
export default class {
  constructor(telServer, campaign, guid, stunTurnConfs, __endcall) {
    this.ua = null;
    this.line1 = null;
    this.remoteView = undefined;
    this.selfView = undefined;
    this.__endcall = __endcall;
    this.campaign = campaign;

    this.telserver = telServer;
    this.guid = guid;
    this.mynumber = "web";
    this.mypassword = "uC0nt4ctW3bch4t";
    this.voice = true;

    this.stunTurnConfs = stunTurnConfs;

    if (navigator.userAgent.indexOf("Chrome") != -1) {
      this.voice =
        "{ mandatory : { googEchoCancellation: true, googEchoCancellation2: true, googAutoGainControl: true, googNoiseSuppression: true, googHighpassFilter: true, googTypingNoiseDetection: true } }";
    }

    this.socket = new JsSIP.WebSocketInterface(
      "wss://" + this.telserver + ":8089/ws"
    );

    this.configuration = {
      sockets: [this.socket],
      uri: "sip:" + this.mynumber + "@" + this.telserver,
      password: this.mypassword,
      session_timers: false,
      realm: "asterisk",
      register: false,
    };

    window.onbeforeunload = (event) => {
      this.hangUp();
      return null;
    };
  }

  setVideoElements(me, agent, store) {
    this.selfView = me;
    this.remoteView = agent;
    this.store = store;
  }

  startUA() {
    if (this.ua === null) {
      this.ua = new JsSIP.UA(this.configuration);
      this.ua.start();
      this.attachUAEventHandlers();
    }
  }

  attachUAEventHandlers() {
    this.ua.on("registered", (data) => {});
    this.ua.on("connecting", (data) => {});
    this.ua.on("connected", (data) => {});
    this.ua.on("disconnected", (data) => {});
    this.ua.on("unregistered", (data) => {});
    this.ua.on("registrationFailed", (data) => {});
    this.ua.on("newMessage", (data) => {});
    this.ua.on("newRTCSession", (data) => {
      this.line1 = data.session;
      this.attachCallEventHandlers();
    });
  }

  attachCallEventHandlers() {
    // this.line1.on('peerconnection', (data) => {});
    // this.line1.on('progress', (data) => {});
    // this.line1.on('accepted', (data) => {});
    // this.line1.on('newDTMF', (data) => {});
    // this.line1.on('hold', (data) => {});
    // this.line1.on('unhold', (data) => {});
    // this.line1.on('muted', (data) => {});
    // this.line1.on('unmuted', (data) => {});
    // this.line1.on('reinvite', (data) => {});
    // this.line1.on('update', (data) => {});
    // this.line1.on('refer', (data) => {});
    // this.line1.on('replaces', (data) => {});
    // this.line1.on('sdp', (data) => {console.log('sdp')});
    // this.line1.on('sending', (data) => {console.log('sending')});

    var myCandidateTimeout = null;

    this.line1.on("icecandidate", function (candidate, ready) {
      //console.log('getting a candidate' + candidate.candidate.candidate);
      if (myCandidateTimeout != null) clearTimeout(myCandidateTimeout);
      // 3 seconds timeout after the last icecandidate received!
      myCandidateTimeout = setTimeout(candidate.ready, 3000);
    });

    this.line1.on("connecting", (data) => {
      this.attachRTCHandlers();
    });

    this.line1.on("confirmed", (data) => {
      this.chat.sendStartCallEvent(this.video);
    });

    var end = this.__endcall;
    this.line1.on("ended", (data) => {
      if (typeof data.message !== "undefined" && data.message !== null) {
        if (
          typeof data.message.headers !== "undefined" &&
          data.message.headers !== null
        ) {
          if (
            typeof data.message.headers["X-Asterisk-Hangupcausecode"] !==
              "undefined" &&
            data.message.headers["X-Asterisk-Hangupcausecode"] !== null
          ) {
            if (
              typeof data.message.headers["X-Asterisk-Hangupcausecode"][0]
                .raw !== "undefined" &&
              data.message.headers["X-Asterisk-Hangupcausecode"][0].raw !== null
            ) {
              if (
                typeof data.message.headers["X-Asterisk-Hangupcausecode"][0]
                  .raw !== "undefined" &&
                data.message.headers["X-Asterisk-Hangupcausecode"][0].raw === 19
              ) {
              }
            }
          }
        }
      }

      this.chat.sendEndCallEvent(this.video);

      window.parent.postMessage(
        { action: "HANGUP_CALL", video: this.video },
        "*"
      );

      this.line1 = null;
      this.audio = false;
      this.video = false;

      end();
    });

    this.line1.on("failed", (data) => {
      this.line1 = null;
      this.audio = false;
      this.emptyVideo();
      this.video = false;
      console.log("failed");
      if (data.cause === "Canceled") {
        console.log("cause canceled");
      }
    });
  }

  attachRTCHandlers() {
    this.line1.connection.onaddstream = (data) => {
      this.remoteView.srcObject = data.stream;
    };

    this.line1.connection.onremovestream = (data) => {
      console.log("Removestream...");
    };

    this.line1.connection.ontrack = (data) => {
      this.remoteView.srcObject = data.streams[0];
    };

    this.line1.connection.addEventListener(
      "iceconnectionstatechange",
      (data) => {
        if (data.target.iceConnectionState == "connected") {
          let localStream = new MediaStream();
          this.line1.connection.getSenders().forEach((sender) => {
            localStream.addTrack(sender.track);
          });

          this.selfView.srcObject = localStream;
        }
      }
    );
  }

  //si video es true, la llamada es una videollamada
  makeCall(destination, video) {
    if (this.ua.status === 1) {
      if (this.line1 == null) {
        let options = {
          mediaConstraints: {
            audio: this.voice,
            video: video,
          },
          extraHeaders: ["CAMPAIGN: " + this.campaign, "GUID:" + this.guid],
          pcConfig: {
            iceServers: [this.getTurnCredentials()],
          },
        };

        this.ua.call("sip:" + destination + "@" + this.telserver, options);
        this.video = video;

        window.parent.postMessage({ action: "MAKE_CALL", video: video }, "*");
      }
    } else {
      setTimeout(() => {
        this.makeCall(destination, video);
      }, 1000);
    }
  }

  hangUp() {
    if (this.ua != null) {
      this.ua.terminateSessions();
    }
    this.line1 = null;
  }

  SendDTMF(dtmfval) {
    if (this.line1 != null) {
      this.line1.sendDTMF(dtmfval);
    }
  }

  mute() {
    if (this.line1 != null) {
      this.line1.mute();
    }
  }

  unmute() {
    if (this.line1 != null) {
      this.line1.unmute();
    }
  }

  emptyVideo() {
    this.remoteView.src = "";
    this.selfView.src = "";
  }

  getTurnCredentials() {
    let result;
    if (
      this.stunTurnConfs.ScreenShareTurn &&
      this.stunTurnConfs.ScreenShareTurnUser &&
      this.stunTurnConfs.ScreenShareTurnPass
    ) {
      result = {
        urls: [
          "turn:" + this.stunTurnConfs.ScreenShareTurn,
          "stun:stun.l.google.com:19302",
          "stun:stun.ucontactcloud.com",
        ],
        username: this.stunTurnConfs.ScreenShareTurnUser,
        credential: this.stunTurnConfs.ScreenShareTurnPass,
      };
    } else {
      result = {
        urls: ["stun:stun.l.google.com:19302", "stun:stun.ucontactcloud.com"],
      };
    }
    return result;
  }
}
